import {
  getPostPage,
  addPost,
  updatePost,
  deletePost,
  getAllPostList,
} from '@/_serveice/admin/system';
import { message } from 'antd';

export default {
  namespace: 'position',
  state: {
    postList: [],
    allPostList: [], // For tag management or other uses
  },
  effects: {
    *getPostPage({ payload }, { call, put }) {
      const res = yield call(getPostPage, payload);
      if (res?.success) {
        yield put({
          type: 'save',
          payload: {
            postList: res.data,
          },
        });
        return res;
      }
    },
    *addPost({ payload }, { call }) {
      const res = yield call(addPost, payload);
      if (res?.success) {
        message.success('新增成功');
        return res;
      }
    },
    *updatePost({ payload }, { call }) {
      const res = yield call(updatePost, payload);
      if (res?.success) {
        message.success('修改成功');
        return res;
      }
    },
    *deletePost({ payload }, { call }) {
      const res = yield call(deletePost, payload);
      if (res?.success) {
        message.success('删除成功');
        return res;
      }
    },
    *getAllPostList({ payload }, { call, put }) {
      const res = yield call(getAllPostList, payload);
      if (res?.success) {
        yield put({
          type: 'save',
          payload: {
            allPostList: res.data,
          },
        });
        return res.data;
      }
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
